import { canStaff, isStaffMember } from '@/libs/staffPermissions'

export function canUserSeeNavItem(user, link) {
  if (!user?.role || !link) {
    return false
  }

  let allowed = false

  if (user.role === 'Admin') {
    allowed = true
  } else if (user.role === link.resource) {
    allowed = true
  } else if (link.resource === 'Admin') {
    allowed = false
  } else if (link.resource === 'Company Owner') {
    allowed = false
  } else if (link.resource === 'Supervisor') {
    allowed = user.role === 'Company Owner'
  } else {
    allowed = true
  }

  if (allowed && link.requiresStaffPermission && isStaffMember(user)) {
    const { subject, ability } = link.requiresStaffPermission
    return canStaff(user, ability, subject)
  }

  return allowed
}

export function canUserSeeNavGroup(user, group) {
  if (!user?.role || !group) {
    return false
  }

  if (user.role === 'Admin' && group.noAdmin) {
    return false
  }

  const hasAnyVisibleChild = (group.children || []).some((child) => canUserSeeNavItem(user, child))
  if (!hasAnyVisibleChild) {
    return false
  }

  if (group.action && group.resource) {
    return canUserSeeNavItem(user, group)
  }

  return true
}
